import { useContext, useEffect, useState } from 'react';
import ScanDeliveryBatchDialog from '../driver-delivery-tasks/scan-delivery-batch-dialog';
import { IDeliveryBatch } from '../../../interfaces/delivery-company/tasks';
import { API_ENDPOINT } from '../../../configurations/global.config';
import axios from 'axios';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import { DeliveryBatchState } from '../../../enums/tasks';
import { Alert, CircularProgress } from '@mui/material';
import SnackBar from '../../common/snack-bar/snack-bar';
import { useSnackBar } from '../../../contexts/snackbar';

interface DeliveryBatchQuickScanDialogProps {
  id: string;
  onClose: () => void;
}
function DeliveryBatchQuickScanDialog({
  id,
  onClose,
}: DeliveryBatchQuickScanDialogProps) {
  const [deliveryBatch, setDeliveryBatch] = useState<IDeliveryBatch>();
  const [snackBar, setSnackBar] = useState<timestampedMessage>();
  const [isLoading, setIsLoading] = useState(false);
  const { showMessage } = useSnackBar();

  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    const fetchBatch = async () => {
      try {
        setIsLoading(true);
        const endpoint = `${API_ENDPOINT}/api/v1/delivery-batch/${id}/`;
        const response = await axios.get<IDeliveryBatch>(endpoint, config);
        const batch = response.data;
        if (batch.status !== DeliveryBatchState.ASSIGNED) {
          setSnackBar({
            level: 'error',
            content: 'Batch already collected',
            timestamp: Date.now(),
          });
        } else {
          setDeliveryBatch(response.data);
        }
      } catch (e) {
        setSnackBar({
          content: 'Failed to find batch',
          level: 'error',
          timestamp: Date.now(),
        });
      }
      setIsLoading(false);
    };
    fetchBatch();
  }, []);

  return (
    <>
      {isLoading ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CircularProgress />{' '}
        </div>
      ) : (
        <>
          {deliveryBatch ? (
            <ScanDeliveryBatchDialog
              task={deliveryBatch}
              onClose={onClose}
              setSnackBarResult={(t) => {
                showMessage(t?.content ?? 'No content', t?.level);
              }}
            />
          ) : (
            <Alert severity="error">Batch not found</Alert>
          )}
        </>
      )}
      {snackBar && snackBar.content && (
        <SnackBar
          message={snackBar.content}
          level={snackBar.level}
          key={snackBar.timestamp}
        />
      )}
    </>
  );
}

export default DeliveryBatchQuickScanDialog;
